<div (window:resize)="onResize($event)" (mouseenter)="mouseEnter()">
    <div class="container-fluid">

        <div class="btns-container" style="position:absolute;top:7px;right:1px;">

            <a id="addTagsAssessments" (click)="openCSVDownloadModal()" [ngClass]="{'btn-primary': _Globals.completedCanAddTags, 'btn-gray': !_Globals.completedCanAddTags}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                <i class="fas fa-download text-white-50"> <span class="button-text"> Group averages</span></i>
            </a>

            <a id="addTagsAssessments" (click)="openAddTagsAssessmentsModal()" [ngClass]="{'btn-primary': _Globals.completedCanAddTags, 'btn-gray': !_Globals.completedCanAddTags || selectedRowsCount === 0}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                <i class="fas fa-tag text-white-50"> <span class="button-text"> Tags</span></i>
            </a> 

            <a id="archiveAssessments" (click)="openArchiveAssessmentsConfirmationModal()" [ngClass]="{'btn-primary': _Globals.completedCanArchiveAssessments, 'btn-gray': !_Globals.completedCanArchiveAssessments}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                <i class="fas fa-archive text-white-50"> <span class="button-text"> Archive </span></i>
            </a>

            <a *ngIf="!enabling; else enablingResults;" id="enableResults" (click)="enableClientSeeResults()" [ngClass]="{'btn-other': _Globals.completedCanEnableResults, 'btn-gray': !_Globals.completedCanEnableResults}" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5">
                <i class="fas fa-toggle-on text-white-50"> <span class="button-text"> Enable Results</span></i>
            </a>

            <ng-template #enablingResults>
                <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Enabling Results
                </button>
            </ng-template>
            <!--<a id="ccShowFilter" (click)="showFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
                <i class="fas fa-filter text-white-50"> <span class="button-text"> Search</span></i>
            </a>
            <a id="cHideFilter" (click)="hideFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
                <i class="fas fa-filter text-white-50"> <span class="button-text"> Hide Search</span></i>
            </a>-->
            <!--<a (click)="assignRaters()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canAddRaters, 'btn-gray': !canAddRaters}">
                <i class="fas fa-users text-white-50"> <span class="button-text"> Raters</span></i>
            </a>-->
        </div>

        <ng-container *ngIf="loading">
            <div class="loading text-center">
                <br />
                <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                <br />
                <p>Loading, please wait...</p>
            </div>
        </ng-container>

        <div class="row">

            <div>
                <ul class="nav nav-tabs completedTabs">
                    <li (click)="tabSelected(2.1)" class="active"><a data-toggle="tab" href="#completedTab1">ELI - Self Assessment</a></li>
                    <li (click)="tabSelected(2.2)"><a data-toggle="tab" href="#completedTab2">ELI 360</a></li>
                </ul>
            </div>

            <div class="tab-content completedTabs">
                <div id="completedTab1" class="tab-pane fade in active">
                    <div class="row container-fluid">
                        <div class="col-xs-9 col-sm-5">
                            <tag-input [(ngModel)]='tags'
                                       [addOnBlur]="true"
                                       (onRemove)="onItemRemoved(1, $event)"
                                       (onAdd)="onItemAdded(1, $event)"
                                       [secondaryPlaceholder]="placeholder"
                                       [placeholder]="placeholder"
                                       [inputId]="'completedTagsInput'"
                                       (onFocus)="onFocusInput()"
                                       [theme]="'foundation-theme'"></tag-input>
                            <i class="fas fa-search searchIcon" (click)="focusTagsInput('completedTagsInput')"></i>
                            <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(1)">My tags</a>
                        </div>
                        <i style="margin-left: 15px;position: relative;top: 20px;" [popover]="help" class="fas fa-question-circle pointer"></i>
                        <popover-content #help
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>

                    <br />

                    <div id="completedAssessments" style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="this._Globals.completedRegularData"
                                         [columnDefs]="dataHeaders"
                                         [enableSorting]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClicked($event)"
                                         (gridReady)="onGridReady(1, $event)"
                                         [rowSelection]="rowSelection"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [floatingFilter]="true"
                                         (selectionChanged)="onSelectionChanged($event)">
                        </ag-grid-angular>
                    </div>
                </div>

                <div id="completedTab2" class="tab-pane fade">
                    <div class="row container-fluid">
                        <!--<div class="col-xs-4 col-sm-offset-5 col-sm-2" >
                            <h5>Search by tag:</h5>
                        </div>-->
                        <div class="col-xs-9 col-sm-5">
                            <tag-input [(ngModel)]='tags360'
                                       [addOnBlur]="true"
                                       (onRemove)="onItemRemoved(2, $event)"
                                       (onAdd)="onItemAdded(2, $event)"
                                       [secondaryPlaceholder]="placeholder"
                                       [placeholder]="placeholder"
                                       [inputId]="'completedTagsInput360'"
                                       (onFocus)="onFocusInput()"
                                       [theme]="'foundation-theme'"></tag-input>
                            <i class="fas fa-search searchIcon" (click)="focusTagsInput('completedTagsInput360')"></i>
                            <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(2)">My tags</a>
                        </div>
                        <i style="margin-left: 15px;position: relative;top: 20px;" [popover]="help360" class="fas fa-question-circle pointer"></i>
                        <popover-content #help360
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>

                    <br />

                    <div id="completedAssessments" style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="this._Globals.completed360Data"
                                         [columnDefs]="dataHeaders"
                                         [enableSorting]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClicked($event)"
                                         (gridReady)="onGridReady(2, $event)"
                                         [rowSelection]="rowSelection"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [floatingFilter]="true"
                                         (selectionChanged)="onSelectionChanged($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*ADD TAGS modal*/-->
<div id="completedAddTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add tags</h2>
                <button (click)="closeAddTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row container-fluid">
                    <div class="col-xs-2">
                        <span>Tags</span>
                        <i style="margin-left:0;position:relative;top:0;" [popover]="help" class="fas fa-question-circle pointer"></i>
                        <popover-content #help
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>
                    <div class="col-xs-8" style="margin-top: -10px;">
                        <tag-input [(ngModel)]='addTags'
                                   [addOnBlur]="true"
                                   (onRemove)="onItemRemoved(3, $event, true)"
                                   (onAdd)="onItemAdded(3, $event)"
                                   [secondaryPlaceholder]="placeholder"
                                   [placeholder]="placeholder"
                                   [inputId]="'completedTagsInput'"
                                   (onFocus)="onFocusInput()"
                                   [theme]="'foundation-theme'"></tag-input>
                        <i class="fas fa-search searchIcon" (click)="focusTagsInput('completedTagsInput')"></i>
                    </div>
                    <div class="col-xs-2">
                        <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(3)">My tags</a>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeAddTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addAssessmentsTags()" [disabled]="assessmentAddTags.length === 0" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*modal*/-->
<div id="completedTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">My tags</h2>
                <button (click)="closeTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="selectedCoachTags.length > 0" class="tags-wrap">
                    <div *ngFor="let tag of selectedCoachTags; let i = index;" class="tag">
                        {{tag.Text}}
                        <span title="Delete" class="animate fadeInRight" (click)="removeTag(i, tag.Text)">&times;</span>
                    </div>
                </div>

                <div *ngIf="selectedCoachTags.length === 0">
                    <input type="text" placeholder="Select tags from the table" id="placeholderInput" readonly />
                </div>

                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #coachTagsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="gridOptions"
                                     [rowData]="coachTags"
                                     [columnDefs]="coachTagsHeaders"
                                     (gridReady)="onCoachTagsGridReady($event)"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     (rowClicked)="onCoachTagsRowClicked($event)"
                                     (selectionChanged)="onCoachTagsSelectionChanged($event)">
                    </ag-grid-angular>
                </div>

            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addNewCoachTags()" [disabled]="selectedCoachTags.length === 0" type="button" class="btn btn-primary">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Archive Assessments confirmation modal -->
<div id="archiveConfirmationModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Archive Assessements</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to archive the selected assessments?</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button *ngIf="!archiving;" type="button" data-dismiss="modal" class="btn btn-secondary">No</button>
                        <button *ngIf="!archiving; else archivingResults;" (click)="archiveAssessments()" type="button" class="btn btn-primary">Yes</button>
                        <ng-template #archivingResults>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Archiving
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="CSVDownloadModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Download group average</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <div style="display: flex; align-items: center;">
                    <label for="documentNameInput" >Document Name</label>
                    <input type="text" [formControl]="documentNameControl" id="documentNameInput" placeholder="Type name" style="width: 70%; margin-right: 5px" /> <span>.xlsx</span>
                </div>
                <div *ngIf="documentNameControl.valid || !documentNameControl.dirty" class="text-left" style="margin-left: 22%; color:rgba(255,57,65,.9);">&nbsp;</div>
                <div *ngIf="documentNameControl.hasError('required') && documentNameControl.dirty" class="text-left" style="margin-left: 22%; color:rgba(255,57,65,.9);">required!</div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button *ngIf="!downloading;" type="button" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
                        <button *ngIf="!downloading; else downloadingResults;" (click)="downloadGroupAverageFile()" type="button" class="btn btn-primary">Download</button>
                        <ng-template #downloadingResults>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Downloading
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
